<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4>{{ $t('vouchers.add') }}</h4>
          </div>
          <div class="card-body">
            <VouchersForm ref="voucherForm" @submit-requested="formSubmitted" :loading="loading" />
          </div>
        </div>
      </div>
    </div>
    
    <!-- Modal de código duplicado -->
    <CModal
      :show.sync="showDuplicateCodeModal"
      :title="$t('vouchers.duplicateCodeTitle')"
      color="primary"
    >
      <p>{{ $t('vouchers.duplicateCodeMessage', { code: duplicateCode }) }}</p>
      <template #footer>
        <CButton @click="showDuplicateCodeModal = false" color="primary">{{ $t('confirmPopUp') }}</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import VouchersForm from './VouchersForm.vue';
import router from '@/router';
import { mapActions } from 'vuex';
import { CModal, CButton } from '@coreui/vue';
import InputGetList from "@/classes/InputGetList";

export default {
  components: {
    VouchersForm,
    CModal,
    CButton
  },
  data() {
    return {
      loading: false,
      showDuplicateCodeModal: false,
      duplicateCode: ''
    }
  },
  methods: {
    ...mapActions('vouchers', ['create', 'getVouchers']),
    async checkCodeExists(code) {
      try {
        const input = new InputGetList(1000, 1, code, 1, "Code");
        const response = await this.getVouchers({ 
          input, 
          isActive: null, 
          experienceId: null, 
          isArchived: null 
        });
        
        if (response && response.data && Array.isArray(response.data)) {
          // Check if any voucher has the exact same code (case-insensitive)
          return response.data.some(voucher => 
            voucher.code && voucher.code.toLowerCase() === code.toLowerCase()
          );
        }
        return false;
      } catch (error) {
        console.error('Error checking code existence:', error);
        return false;
      }
    },
    async formSubmitted(voucherData) {
      try {
        // Check if code already exists
        const codeExists = await this.checkCodeExists(voucherData.code);
        if (codeExists) {
          this.duplicateCode = voucherData.code;
          this.showDuplicateCodeModal = true;
          this.loading = false;
          // Reset submitting state in form to show button again
          if (this.$refs.voucherForm) {
            this.$refs.voucherForm.resetSubmitting();
          }
          return;
        }
        
        this.loading = true;
        await this.create(voucherData);
        router.push({ name: 'VouchersList' });
      } catch (error) {
        console.error('Error creating voucher:', error);
        this.loading = false;
        // Reset submitting state in form to show button again
        if (this.$refs.voucherForm) {
          this.$refs.voucherForm.resetSubmitting();
        }
      }
    }
  }
}
</script>

